import { type AccountKanbanCardRead } from '@libraries/typescript/api_client';

export type AccountHealthStatus = AccountKanbanCardRead['health_status'];
export type AccountHealthVerdictSelection =
    | Exclude<AccountHealthStatus, 'neutral'>
    | 'no_change';

export const ACCOUNT_HEALTH_STATUS_CONFIG = {
    red: {
        label: 'Red',
        dotClassName: 'bg-red-500',
        sortRank: 0,
    },
    yellow: {
        label: 'Yellow',
        dotClassName: 'bg-yellow-400',
        sortRank: 1,
    },
    neutral: {
        label: 'Neutral',
        dotClassName: 'border-muted-foreground/50 border bg-transparent',
        sortRank: 2,
    },
    green: {
        label: 'Green',
        dotClassName: 'bg-green-500',
        sortRank: 3,
    },
} as const satisfies Record<
    AccountHealthStatus,
    {
        readonly label: string;
        readonly dotClassName: string;
        readonly sortRank: number;
    }
>;
